const VALIDATOR_TYPE_REQUIRE = 'REQUIRE';
const VALIDATOR_TYPE_MINLENGTH = 'MINLENGTH';
const VALIDATOR_TYPE_MAXLENGTH = 'MAXLENGTH';
const VALIDATOR_TYPE_MIN = 'MIN';
const VALIDATOR_TYPE_MAX = 'MAX';
const VALIDATOR_TYPE_EMAIL = 'EMAIL';
const VALIDATOR_TYPE_FILE = 'FILE';
const VALIDATOR_TYPE_CAPITAL = 'CAPITAl';
const VALIDATOR_TYPE_DIGIT = 'DIGIT';
const VALIDATOR_TYPE_SYMBOL = 'SYMBOL';
const VALIDATOR_TYPE_EXIST = 'EXIST';
const VALIDATOR_TYPE_ENGLISH_CHARACTERS = 'ENGLISH_CHARACTERS';
const VALIDATOR_TYPE_ENGLISH_CHARACTERS_NOT_REQUIRED =
  'ENGLISH_CHARACTERS_NOT_REQUIRED';

export const VALIDATOR_REQUIRE = () => ({ type: VALIDATOR_TYPE_REQUIRE });
export const VALIDATOR_FILE = () => ({ type: VALIDATOR_TYPE_FILE });
export const VALIDATOR_MINLENGTH = (val) => ({
  type: VALIDATOR_TYPE_MINLENGTH,
  val: val,
});
export const VALIDATOR_MAXLENGTH = (val) => ({
  type: VALIDATOR_TYPE_MAXLENGTH,
  val: val,
});
export const VALIDATOR_CAPITAL = () => ({ type: VALIDATOR_TYPE_CAPITAL });
export const VALIDATOR_DIGIT = () => ({ type: VALIDATOR_TYPE_DIGIT });
export const VALIDATOR_SYMBOL = () => ({ type: VALIDATOR_TYPE_SYMBOL });
export const VALIDATOR_EXIST = (a) => ({ type: VALIDATOR_TYPE_EXIST, val: a });
export const VALIDATOR_MIN = (val) => ({ type: VALIDATOR_TYPE_MIN, val: val });
export const VALIDATOR_MAX = (val) => ({ type: VALIDATOR_TYPE_MAX, val: val });
export const VALIDATOR_EMAIL = () => ({ type: VALIDATOR_TYPE_EMAIL });
export const VALIDATOR_ENGLISH_CHARACTERS = (val) => ({
  type: VALIDATOR_TYPE_ENGLISH_CHARACTERS,
  val: val,
});

export const VALIDATOR_ENGLISH_CHARACTERS_NOT_REQUIRED = (val) => ({
  type: VALIDATOR_TYPE_ENGLISH_CHARACTERS_NOT_REQUIRED,
  val: val,
});

export const validate = (value, validators) => {
  let isValid = true;
  for (const validator of validators) {
    if (validator.type === VALIDATOR_TYPE_REQUIRE) {
      isValid = isValid && value.trim().length > 0;
    }
    if (validator.type === VALIDATOR_TYPE_ENGLISH_CHARACTERS) {
      isValid = isValid && /^[A-Za-z][A-Za-z0-9]*$/.test(value);
    }
    if (validator.type === VALIDATOR_TYPE_ENGLISH_CHARACTERS_NOT_REQUIRED) {
      isValid =
        isValid && value === ''
          ? true
          : isValid && /^[A-Za-z][A-Za-z0-9]*$/.test(value);
    }
    if (validator.type === VALIDATOR_TYPE_MINLENGTH) {
      isValid = isValid && value.trim().length >= validator.val;
    }
    if (validator.type === VALIDATOR_TYPE_MAXLENGTH) {
      isValid = isValid && value.trim().length <= validator.val;
    }
    if (validator.type === VALIDATOR_TYPE_MIN) {
      isValid = isValid && +value >= validator.val;
    }
    if (validator.type === VALIDATOR_TYPE_MAX) {
      isValid = isValid && +value <= validator.val;
    }
    if (validator.type === VALIDATOR_TYPE_EMAIL) {
      isValid =
        (isValid && /.*@cheil.com/.test(value)) || /.*@samsung.com/.test(value) || /.*@cheilpengtai.com/.test(value) || /.*@partner.samsung.com/.test(value)|| /.*@centrade-cheil.com/.test(value);
    }
    if (validator.type === VALIDATOR_TYPE_CAPITAL) {
      isValid = isValid && /[A-Z]/.test(value);
    }
    if (validator.type === VALIDATOR_TYPE_DIGIT) {
      isValid = isValid && /[0-9]/.test(value);
    }
    if (validator.type === VALIDATOR_TYPE_SYMBOL) {
      isValid = isValid && /[-!@#$%^&*()_+|~=`{}\[\]:";'<>?,.\/]/.test(value);
    }
    if (validator.type === VALIDATOR_TYPE_EXIST) {
      isValid = isValid && !validator.val.includes(value);
    }
  }
  return isValid;
};
